import { render, staticRenderFns } from "./ExcluirProducao.vue?vue&type=template&id=6bbc22bc&scoped=true"
import script from "./ExcluirProducao.vue?vue&type=script&lang=js"
export * from "./ExcluirProducao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc22bc",
  null
  
)

export default component.exports